import React,{useEffect} from 'react';
import Header from '../../components/Header';
import ChangePassStdMain from './ChangePassStdMain';
import Footer from '../../components/Footer';


const ChangePassStd = () => {
          useEffect(() => {
        document.title = "Forgot password | Society of Aquaculture Professionals";
      }, []);
  return (
    <>
      <Header/>

      <ChangePassStdMain />

      <Footer/>
    </>
  );
};

export default ChangePassStd;
